// /**
//  * This file is used to aggregate all the css files that are used by our views.  This is necessary because with webpack chunks,
//  * extract text is unable to create a style sheet for individual chunks.  To get around this, we load all the chunked styles
//  * here.
//  */
//

//Component style
import './common/modal/Modal.sass';
import './common/modal/ErrorModal.sass';
import './common/alert/AlertStyle.sass';
import './common/badge/Badge.sass';
import './common/button/Button.sass';
import './common/form/validatingInput.sass';
import './common/form/validatingSelect.sass';
import './common/form/validatingTextArea.sass';
import './common/form/validationCheckbox.sass';
import './common/spacer/Spacer.sass';
import './common/spacer/PrizeSpacer.sass';
import './common/text/Text.sass';
import './common/loading/Loading.sass';
import './common/select/Select.sass';
import './payout/PayoutForm.sass';
import './redeem/RedeemForm.sass';
import './login/LoginWrapper.sass';
import './prize/Prize.sass';
import './prize/Tabs.sass';
import './prize/TaxProfile.sass';
import './prize/AccountId.sass';
import './prize/Heading.sass';
import './progress/Progress.sass';
import './common/svg/Svg.sass';
import './prize/ExpandButton.sass';
import './common/button/SwitchButton.sass';
import './access/LegalAccess.sass';
import './payout/taxInfo/InterviewFailed.sass';
